import React, { PropTypes } from 'react';

import './styles.scss';


const Reviews = ({ children, ...props }) => (
  <ul styleName='reviews' {...props}>

    { children }

  </ul>
);

Reviews.propTypes = {
  children: PropTypes.node,
};

Reviews.defaultProps = {
  children: null,
};

export default Reviews;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/User/components/Reviews/index.jsx